
import { useFullscreen } from '@vueuse/core'
import { eoRendererMixin, metaDataMixin } from '~/mixins'

export default {
  mixins: [
    eoRendererMixin,
    metaDataMixin,
  ],
  layout: 'bijbellab',
  async asyncData ({ $api, $config, store, route: { path }, error }) {
    const slug = path.substr(path.indexOf('/') + 1)
    
    const {
      data: {
        items: page = [],
      } = {},
    } = await $api.pages.getOneBySlug(slug, {
      domain: $config.preprEnvironmentDomainEo,
    })

    // check publication if exists and is complete
    if (!page || !page.length) {
      error({
        context: `Couldn't create '${slug}' page.`,
        message: '(404) Pagina niet gevonden',
        severity: 'info',
        statusCode: 404,
      })
      return false
    }

    store.dispatch('breadcrumbs/set', {
      path,
      eoRoot: true,
      floating: false,
      width: 6,
      items: [
        {
          to: '/bijbel-lab',
          label: 'Bijbel_Lab',
        },
        {
          label: `${page[0].title}`,
        },
      ],
    })

    return page[0]
  },
  data () {
    return {
      content: null,
      featuredVideo: null,
      hero: null,
      id: null,
      intro: null,
      isFullscreen: false,
      isExperimentBuild: null,
      isMounted: false,
      likes: null,
      seo: null,
      slug: null,
      social: null,
      subtitle: null,
      title: null,
      isSharingPossible: true,
      showHyperlink: false,
      isCopySuccesfull: false,
      shareText: 'Probeer dit experiment',
      shareUrl: null,
      showSplash: true,
    }
  },
  computed: {
    experimentName () {
      return this.slug?.split('/').pop()?.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join('')
    },
    isIos () {
      return process.client ? /iPhone|iPod/.test(navigator.userAgent) : false
    },
    enterFullscreen () {
      const { enter } = useFullscreen(this.$refs.experiment)
      return enter
    },
    exitFullscreen () {
      const { exit } = useFullscreen(this.$refs.experiment)
      return exit
    },
  },
  async mounted () {
    try {
      this.isExperimentBuild = Boolean(await import(`~/components/Bijbellab/${this.experimentName}.vue`))
    } catch (error) {
      this.isExperimentBuild = false
    }
    this.isMounted = true

    this.isSharingPossible = navigator.share || navigator.clipboard
    this.shareUrl = `${this.$config.baseUrl}/bijbel-lab/${this.experimentName}`

    document.addEventListener('fullscreenchange', () => { 
      if (document.fullscreenElement) { 
        this.isFullscreen = true
      } else { 
        this.isFullscreen = false
      }
    })
  },
  methods: {
    toggleFullscreen () {
      if (this.isFullscreen) {
        this.exitFullscreen()
      } else {
        this.enterFullscreen()
      }
    },
    async shareExperiment () {
      try {
        await navigator.share({ 
          text: this.shareText, 
          url: this.shareUrl,
        })
      } catch (error) {
        this.showHyperlink = !this.showHyperlink
      }

      // Send event to Prepr
      window.prepr('event', 'Share', { constraint: true })

      // Send event to GTM
      if (this.$gtm) {
        this.$gtm.push({
          event: 'eo_share',
          'content_type': 'page',
          'item_id': this.id,
        })
      }
    },
    async copyHyperlink () {
      try {
        await navigator.clipboard.writeText(this.shareUrl)
        this.isCopySuccesfull = true
      } catch (error) {
        try {
          this.$refs.hyperlink?.$el?.select()
          document.execCommand('copy')
          this.isCopySuccesfull = true
        } catch (error) {
          this.isCopySuccesfull = false
        }
      }
    },
  },
}
